import { render, staticRenderFns } from "./lawsuit-follow-force.vue?vue&type=template&id=03db6d6e&scoped=true"
import script from "./lawsuit-follow-force.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-force.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db6d6e",
  null
  
)

export default component.exports